<dx-data-grid
  *ngIf="vehicleService"
  height="100%"
  width="auto"
  [dataSource]="vehicleService.schedules"
  [remoteOperations]="false"
  (onRowInserting)="onScheduleInserting($event)"
  (onRowUpdating)="onScheduleUpdating($event)"
  (onRowRemoving)="onScheduleRemoving($event)">
  <!-- Settings -->
  <dxo-editing mode="row" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"></dxo-editing>
  <dxo-export [enabled]="true" fileName="schedules-export"></dxo-export>

  <!-- Columns -->
  <dxi-column caption="Scheduled For" dataField="scheduledFor" dataType="date" [allowEditing]="true">
    <dxi-validation-rule type="required" message="Scheduled date is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column caption="Remind On" dataField="remindOn" dataType="date" [allowEditing]="true"> </dxi-column>
  <dxi-column caption="Description" dataField="description" dataType="string" [allowEditing]="true">
    <dxi-validation-rule type="required" message="Description is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column
    caption="Created At"
    dataField="createdAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"></dxi-column>
  <dxi-column caption="Created By" dataField="createdBy.username" [allowEditing]="false"></dxi-column>
</dx-data-grid>
